/**
 * @generated SignedSource<<0c57c62367115ad2405b1ee4b17a9482>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type WorkbookHistoryTypeEnum = "created" | "deactivated" | "published" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type WorkbookWorkbookHistoryPaginator_workbook$data = {
  readonly histories: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly type: WorkbookHistoryTypeEnum;
        readonly " $fragmentSpreads": FragmentRefs<"WorkbookHistoryTimelineItem_workbookHistory">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number | null;
  };
  readonly id: string;
  readonly " $fragmentType": "WorkbookWorkbookHistoryPaginator_workbook";
};
export type WorkbookWorkbookHistoryPaginator_workbook$key = {
  readonly " $data"?: WorkbookWorkbookHistoryPaginator_workbook$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkbookWorkbookHistoryPaginator_workbook">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "histories"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WorkbookWorkbookHistoryPaginatorRefreshQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "WorkbookWorkbookHistoryPaginator_workbook",
  "selections": [
    {
      "alias": "histories",
      "args": null,
      "concreteType": "WorkbookHistoryConnection",
      "kind": "LinkedField",
      "name": "__WorkbookWorkbookHistoryPaginator_workbook_histories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkbookHistoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WorkbookHistory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkbookHistoryTimelineItem_workbookHistory"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Workbook",
  "abstractKey": null
};
})();

(node as any).hash = "68d7ef94825791d3638436f000d05c94";

export default node;
